export interface ShellSkinPalette {
  readonly shell: readonly [string, string, string];
  readonly shadow: string;
  readonly gateLip: string;
}

const defaultPalette: ShellSkinPalette = {
  shell: ["rgba(53, 240, 255, 0.78)", "rgba(255, 59, 167, 0.72)", "rgba(112, 255, 138, 0.76)"],
  shadow: "rgba(53, 240, 255, 0.24)",
  gateLip: "rgba(233, 251, 255, 0.82)"
};

const palettes: Record<string, ShellSkinPalette> = {
  white_arc: defaultPalette,
  cyan_pulse: {
    shell: ["rgba(53, 240, 255, 0.84)", "rgba(135, 250, 255, 0.72)", "rgba(233, 251, 255, 0.68)"],
    shadow: "rgba(53, 240, 255, 0.3)",
    gateLip: "rgba(233, 251, 255, 0.86)"
  },
  lime_flux: {
    shell: ["rgba(112, 255, 138, 0.82)", "rgba(53, 240, 255, 0.68)", "rgba(218, 255, 110, 0.72)"],
    shadow: "rgba(112, 255, 138, 0.28)",
    gateLip: "rgba(226, 255, 218, 0.86)"
  },
  pink_circuit: {
    shell: ["rgba(255, 59, 167, 0.8)", "rgba(255, 133, 209, 0.7)", "rgba(53, 240, 255, 0.66)"],
    shadow: "rgba(255, 59, 167, 0.28)",
    gateLip: "rgba(255, 220, 242, 0.86)"
  },
  gold_relay: {
    shell: ["rgba(255, 211, 74, 0.82)", "rgba(233, 251, 255, 0.64)", "rgba(53, 240, 255, 0.68)"],
    shadow: "rgba(255, 211, 74, 0.28)",
    gateLip: "rgba(255, 244, 190, 0.88)"
  },
  violet_nova: {
    shell: ["rgba(180, 108, 255, 0.8)", "rgba(255, 59, 167, 0.7)", "rgba(53, 240, 255, 0.66)"],
    shadow: "rgba(180, 108, 255, 0.28)",
    gateLip: "rgba(239, 226, 255, 0.86)"
  },
  emerald_static: {
    shell: ["rgba(72, 255, 183, 0.82)", "rgba(112, 255, 138, 0.72)", "rgba(233, 251, 255, 0.62)"],
    shadow: "rgba(72, 255, 183, 0.28)",
    gateLip: "rgba(215, 255, 236, 0.86)"
  },
  ruby_reactor: {
    shell: ["rgba(255, 78, 112, 0.82)", "rgba(255, 59, 167, 0.7)", "rgba(255, 211, 74, 0.66)"],
    shadow: "rgba(255, 78, 112, 0.28)",
    gateLip: "rgba(255, 222, 228, 0.86)"
  },
  neon_jackpot: {
    shell: ["rgba(255, 211, 74, 0.86)", "rgba(255, 59, 167, 0.76)", "rgba(53, 240, 255, 0.72)"],
    shadow: "rgba(255, 211, 74, 0.32)",
    gateLip: "rgba(255, 244, 190, 0.9)"
  },
  blacklight_alloy: {
    shell: ["rgba(140, 98, 255, 0.78)", "rgba(53, 240, 255, 0.66)", "rgba(255, 59, 167, 0.68)"],
    shadow: "rgba(140, 98, 255, 0.28)",
    gateLip: "rgba(226, 220, 255, 0.84)"
  }
};

export function shellSkinPalette(skinId: string): ShellSkinPalette {
  return palettes[skinId] ?? defaultPalette;
}
